import { useMemo } from 'react'
import { useLoadScript } from '@react-google-maps/api'
import { UseLoadScriptOptions } from '@react-google-maps/api/dist/useLoadScript'
import { GOOGLE_MAPS_API_KEY } from 'utils/constants'

const googleMapsApiKey = GOOGLE_MAPS_API_KEY ?? ''

const useGoogleMaps = (options?: UseLoadScriptOptions) => {
  const { isLoaded, ...rest } = useLoadScript({ ...options, googleMapsApiKey })

  const geocode = useMemo(() => {
    if (!isLoaded) {
      return null
    }

    const { geocode } = new google.maps.Geocoder()

    return geocode
  }, [isLoaded])

  return { ...rest, isLoaded, geocode }
}

export default useGoogleMaps
